import { render } from "./LegendColorRow.vue?vue&type=template&id=56dc88a3&scoped=true"
import script from "./LegendColorRow.vue?vue&type=script&lang=js"
export * from "./LegendColorRow.vue?vue&type=script&lang=js"

import "./LegendColorRow.vue?vue&type=style&index=0&id=56dc88a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dc88a3"]])

export default __exports__